import { styles } from './AvailabilityContent.css';
import AvailabilityOptionStatus from '@jbhi-fi/lanyard-ui/components/AvailabilityOptionStatus';
import React from 'react';
import { DisplayModelOptionStatus } from '../DisplayModelOptionStatus/DisplayModelOptionStatus';
import CircleIcon from '@jbhi-fi/lanyard-ui/components/Icons/Circle';
import {
  ERROR_MESSAGE_UNAVAILABLE_INSTORE,
  UNAVAILABLE_INSTORE,
  UNAVAILABLE_MESSAGE,
} from '../../../../../availability/utils/constants';
import { checkHideInStoreForFamily } from '../../../../utils/checkHideInStoreFamily';
import { useLocalisationContext } from '../../../../context/LocalisationContext';
import { getAvailabilityText } from '../../../../../availability/utils/availabilityUtils';

interface AvailabilityContentProps {
  isPickupOptionsAvailable: boolean;
  isDeliveryAvailable?: boolean;
  isInStoreAvailable: boolean;
  isCncAvailable: boolean;
  isOnlyDisplayAvailable?: boolean;
  isPreOrder?: boolean;
  importantMessaging?: string;
  isPickupAvailableNearby?: boolean;
  isAvailableOutOfRange?: boolean;
  isNextClosestStoreContainer: boolean;
  isStoreOpenInNexthour?: boolean;
  isAwaitingStock?: boolean;
}

export const AvailabilityContent = ({
  isPickupOptionsAvailable,
  isDeliveryAvailable,
  isInStoreAvailable,
  isCncAvailable,
  isOnlyDisplayAvailable,
  isPreOrder,
  importantMessaging,
  isPickupAvailableNearby,
  isAvailableOutOfRange,
  isNextClosestStoreContainer,
  isStoreOpenInNexthour,
  isAwaitingStock,
}: AvailabilityContentProps) => {
  const getUnavailableMessaging = () => {
    if (isPickupAvailableNearby) return UNAVAILABLE_MESSAGE;
    if (isDeliveryAvailable) return ERROR_MESSAGE_UNAVAILABLE_INSTORE;
    return UNAVAILABLE_INSTORE;
  };

  const productFamily = window.Jbhifi['product.metafields']?.online_product?.value?.Family?.Title || '';
  const { excludedProductFamilyForInStore } = useLocalisationContext();
  const isHideInstoreFamily =
    checkHideInStoreForFamily(productFamily?.toLowerCase(), excludedProductFamilyForInStore) && !isInStoreAvailable;

  if (isPickupOptionsAvailable || isNextClosestStoreContainer) {
    return (
      <div data-testid="AvailabilityContent-status">
        {isOnlyDisplayAvailable ? (
          <div className={styles.displayModel}>
            <DisplayModelOptionStatus />
          </div>
        ) : (
          <>
            <div className={styles.pickUpOptionsContainer}>
              <AvailabilityOptionStatus
                isAvailable={isCncAvailable}
                name={getAvailabilityText('Click & Collect', isStoreOpenInNexthour, isAwaitingStock, isCncAvailable)}
                classes={styles.optionStatusContainer}
              />
              {!isPreOrder && !isHideInstoreFamily ? (
                <AvailabilityOptionStatus
                  isAvailable={isInStoreAvailable}
                  name="In-store"
                  classes={styles.optionStatusContainer}
                />
              ) : null}
            </div>

            {importantMessaging && isCncAvailable && (isPreOrder || isAwaitingStock) ? (
              <div className={styles.importantMessagingContainer}>
                <p className={styles.importantMessaging}>{importantMessaging}</p>
              </div>
            ) : null}
          </>
        )}
      </div>
    );
  }
  if (!isOnlyDisplayAvailable && (isPickupAvailableNearby || !isAvailableOutOfRange)) {
    return (
      <div className={styles.notHereButElsewhereContainer}>
        <CircleIcon color={styles.color} />
        <p className={styles.notHereButElsewhereContent} data-testid="localisation-pickup-unavailable">
          {getUnavailableMessaging()}
        </p>
      </div>
    );
  }
  return null;
};
